import { render, staticRenderFns } from "./SubCategory.vue?vue&type=template&id=814bf6fe&scoped=true"
import script from "./SubCategory.vue?vue&type=script&lang=js"
export * from "./SubCategory.vue?vue&type=script&lang=js"
import style0 from "./SubCategory.vue?vue&type=style&index=0&id=814bf6fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814bf6fe",
  null
  
)

export default component.exports